import { dashboardWidgetsPermissionConfig } from '@/_shared';

import { Layout } from '../widget-financial-snapshot-graph-card/layout';
import { Loading as FinancialSnapshotGraphCardLoading } from '../widget-financial-snapshot-graph-card/loading';

export function CashReservesOnHandLoading() {
  return (
    <Layout title={dashboardWidgetsPermissionConfig['cash_reserves_on_hand'].name}>
      <FinancialSnapshotGraphCardLoading />
    </Layout>
  );
}
